export default "__VITE_ASSET__hpU$P294D6Syc2YAJ8_d7g__"